import {Component} from '@angular/core';
import {User} from '../models/user';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {ToastrManager} from 'ng6-toastr-notifications';
import {TranslateService} from '@ngx-translate/core';
import {LocaleService} from '../../services/locale.service';
import {NgxSpinnerService} from 'ngx-spinner';

class LoginUser extends User {
    password: string;
}

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {

    user = new LoginUser();

    constructor(
        private router: Router,
        private authService: AuthService,
        private translateService: TranslateService,
        private toastr: ToastrManager,
        private localeService: LocaleService,
        private spinner: NgxSpinnerService
    ) {
        authService.logout();
        localeService.setDefaultLang();
    }

    login() {
        this.spinner.show();
        this.authService.login(this.user.username, this.user.password).subscribe(
            () => {
                this.router.navigate(['']);
            },
            error => {
                this.translateService.get(
                    'global.alert.error'
                ).subscribe(res => {
                    this.toastr.errorToastr(error, res);
                });
            }
        ).add(() => this.spinner.hide());
    }
}
